import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyCarInspection from "./component";
import { getReportUrl, resetCarHealth } from "../post-inspection-diy/actions";
import { withRouter } from "react-router";
import { createOrder } from "../../../components/mobile/seller-package/action";
import { fetchSellerPackageData } from "../post-inspection-diy-container/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        carHealth: {
            rating,
            reportData: {
                amount,
                status,
                reportToken,
                reportType
            }
        },
        inspectionResponse
    },
    user: {  mobile,  secureToken }

}) => ({
    rating,
    amount,
    status,
    reportToken,
    inspectionResponse,
    mobile,
    secureToken,
    reportType
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getReportUrlConnect: getReportUrl,
    resetCarHealthConnect: resetCarHealth,
    createOrderConenect: createOrder,
    fetchSellerPackageDataConnect: fetchSellerPackageData

}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyCarInspection));
